import React, { useRef } from 'react';
import './InactivityWarning.css';

/**
 * Modal affichée avant la déconnexion automatique par inactivité.
 *
 * Props :
 *  - secondsLeft  : secondes restantes (décrémentées par le hook)
 *  - onStay       : callback "Rester connecté"
 *  - onLogout     : callback "Se déconnecter maintenant"
 */
export default function InactivityWarning({ secondsLeft, onStay, onLogout }) {
  // On mémorise la durée initiale au premier rendu pour figer l'animation CSS.
  // Sans ça, chaque décrémentation de secondsLeft change animationDuration → redémarre l'animation.
  const initialSeconds = useRef(secondsLeft);

  const isLow = secondsLeft <= 30;

  return (
    <div className="iw-backdrop">
      <div className="iw-modal" role="alertdialog" aria-live="assertive">

        {/* Icône pulsante */}
        <div className="iw-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>

        <h2 className="iw-title">Session inactive</h2>

        <p className="iw-desc">
          Vous serez déconnecté automatiquement dans
        </p>

        {/* Compte à rebours */}
        <div className="iw-countdown">
          <span className="iw-seconds" data-low={isLow}>
            {secondsLeft}
          </span>
          <span className="iw-unit">secondes</span>
        </div>

        {/* Barre qui rétrécit — durée fixée au montage */}
        <div className="iw-progress-bar">
          <div
            className="iw-progress-fill"
            style={{ animationDuration: `${initialSeconds.current}s` }}
          />
        </div>

        <div className="iw-actions">
          <button className="iw-btn iw-btn--primary" onClick={onStay} autoFocus>
            Rester connecté
          </button>
          <button className="iw-btn iw-btn--ghost" onClick={onLogout}>
            Se déconnecter maintenant
          </button>
        </div>

        <p className="iw-note">
          Pour protéger votre compte, la session se ferme après inactivité.
        </p>
      </div>
    </div>
  );
}
